import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { EQUIPMENT_SOURCES } from './equipmentMeta';
import { InventoryItemPicker } from './InventoryItemPicker';

// Quick, thumb-friendly "where did it come from" block on the same equipment entry.
export const EquipmentSourcePicker = ({ idx, asset, onPatch }) => (
  <div className="space-y-2 pt-1 border-t border-[#1a1a1a]" data-testid={`equip-source-block-${idx}`}>
    <Label className="text-xs text-[#A3A3A3] uppercase tracking-wider">Equipment Source <span className="text-red-400">*</span></Label>
    <div className="flex flex-wrap gap-1.5">
      {EQUIPMENT_SOURCES.map((s) => (
        <button type="button" key={s.key} data-testid={`equip-source-${s.key}-${idx}`} onClick={() => onPatch(idx, { equipment_source: s.key })}
          className={`px-3 py-2 rounded-full text-xs border transition-colors ${asset.equipment_source === s.key ? 'bg-[#D4AF37] border-[#D4AF37] text-black font-semibold' : 'border-[#262626] text-[#A3A3A3] hover:text-white'}`}>
          {s.label}
        </button>
      ))}
    </div>
    <div className="grid grid-cols-3 gap-2">
      <div>
        <Label className="text-[10px] text-[#737373] uppercase tracking-wider">Qty</Label>
        <Input type="number" min="1" step="1" inputMode="numeric" value={asset.quantity ?? 1} data-testid={`equip-qty-${idx}`}
          onChange={(e) => onPatch(idx, { quantity: Math.max(1, parseInt(e.target.value || '1', 10) || 1) })}
          className="bg-[#141414] border-[#262626] text-white h-9" />
      </div>
      {asset.equipment_source === 'supplier_pickup' && (
        <div className="col-span-2">
          <Label className="text-[10px] text-[#737373] uppercase tracking-wider">Supplier (optional)</Label>
          <Input value={asset.supplier_name || ''} data-testid={`equip-supplier-${idx}`} onChange={(e) => onPatch(idx, { supplier_name: e.target.value })}
            className="bg-[#141414] border-[#262626] text-white h-9" placeholder="e.g. Ferguson" />
        </div>
      )}
    </div>
    {['van_stock', 'shop_warehouse'].includes(asset.equipment_source) && (
      <div>
        <Label className="text-[10px] text-[#737373] uppercase tracking-wider">Inventory item (optional)</Label>
        <InventoryItemPicker type={asset.asset_type_key} value={asset._inv_item} testid={`equip-inv-${idx}`}
          onChange={(it) => onPatch(idx, { _inv_item: it, inventory_item_id: it?.id || null })} />
      </div>
    )}
  </div>
);

export default EquipmentSourcePicker;
